
/** @jsx jsx */

import * as React from "react";
import { emojisStyles, emojiContainerStyle } from "./emojisStyle";
import { jsx } from "@emotion/core";



export enum EmojisValues {
  SAD = "SAD",
  MEH = "MEH",
  HAPPY = "HAPPY",
  VHAPPY = "VHAPPY"
}

const emojis = {
  [EmojisValues.SAD]: {
    title: "TERRIBLE",
    image: require("../../../../images/icons/emoji-sad.svg"),
  },
  [EmojisValues.MEH]: {
    title: "BAD",
    image: require("../../../../images/icons/emoji-meh.svg"),
  },
  [EmojisValues.HAPPY]: {
    title: "GOOD",
    image: require("../../../../images/icons/emoji-happy.svg"),
  },
  [EmojisValues.VHAPPY]: {
    title: "AWESOME",
    image: require("../../../../images/icons/emoji-v-happy.svg")
  },
}

interface EmojisProps {
  onClick: (name: string, emojiEnum: EmojisValues) => void;
  name: string;
  selectedRating: EmojisValues;
}


const Emojis: React.SFC<EmojisProps> = (props) => {
  return (
    <div css={emojisStyles.container}>
      {
        Object.keys(emojis).map((emojiEnum: EmojisValues) => {
          return (
            <div
              css={emojiContainerStyle(props.selectedRating, emojiEnum)}
              onClick={() => { props.onClick(props.name, emojiEnum); }}
            >
              <img
                css={emojisStyles.emoji}
                src={emojis[emojiEnum].image} 
              />
              <div css={emojisStyles.title}>
                {emojis[emojiEnum].title}
              </div>
            </div>
          );
        })
      }
    </div>
  )
}

export default Emojis;